/**
 * Stripe Checkout success redirect — confirms payment and sends user home.
 */
import { useEffect, useState } from 'react';
import { View, Text, StyleSheet, ActivityIndicator } from 'react-native';
import { useRouter, useLocalSearchParams } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';
import { useAuth } from '@/contexts/AuthContext';
import { TYPO } from '@/constants/typography';
import { Check } from 'lucide-react-native';

export default function CheckoutSuccess() {
  const router = useRouter();
  const { theme } = useTheme();
  const { refreshProfile } = useAuth();
  const c = theme.colors;
  const params = useLocalSearchParams();
  const [refreshed, setRefreshed] = useState(false);

  useEffect(() => {
    // Refresh profile to pick up new subscription tier from webhook
    refreshProfile?.()
      .then(() => setRefreshed(true))
      .catch(() => setRefreshed(true));
  }, []);

  useEffect(() => {
    if (refreshed) {
      const timer = setTimeout(() => {
        router.replace('/');
      }, 2500);
      return () => clearTimeout(timer);
    }
  }, [refreshed]);

  return (
    <View style={[styles.container, { backgroundColor: c.background }]}>
      <View style={[styles.iconWrap, { backgroundColor: c.success + '20' }]}>
        <Check size={40} color={c.success} strokeWidth={3} />
      </View>
      <Text style={[styles.heading, { color: c.text }]}>Payment Successful</Text>
      <Text style={[styles.sub, { color: c.textSecondary }]}>
        Your subscription is being activated...
      </Text>
      {!refreshed && <ActivityIndicator color={c.accent} style={{ marginTop: 16 }} />}
      {refreshed && (
        <Text style={[styles.redirect, { color: c.textTertiary }]}>Redirecting home...</Text>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 24 },
  iconWrap: {
    width: 80, height: 80, borderRadius: 4,
    justifyContent: 'center', alignItems: 'center', marginBottom: 20,
  },
  heading: { fontSize: 24, fontFamily: TYPO.heading.bold, marginBottom: 8 },
  sub: { fontSize: 14, fontFamily: TYPO.body.regular, textAlign: 'center' },
  redirect: { fontSize: 12, fontFamily: TYPO.body.regular, marginTop: 16 },
});
